/* FAQs, Tabs layout.
 *
 * Drives `sections/faqs.liquid` when its Layout is Tabs (the About page's
 * Ethos, 2 Oct). From md up the questions are tab titles and the chosen row's
 * open <details> panel is the tab panel; phones keep the accordion, so the
 * tab roles go on only while the desktop layout is showing.
 *
 * The answers are in the page once. Each tab button pairs with the row of the
 * same position; selecting it opens that row's <details> (rows sharing a
 * `name` close the rest natively) and marks the row `.is-selected`, which the
 * CSS shows. Keys as the ARIA tabs pattern: arrows move and select, Home and
 * End jump. Without this file the section stays a working accordion.
 *
 * The section emits its own <script src>, so a page with two of these asks
 * for the file twice; the guard keeps it to one run.
 */
(function () {
  if (window.__ddjFaqTabs) return;
  window.__ddjFaqTabs = true;

  var desktop = window.matchMedia('(min-width: 768px)');

  function init(root) {
    if (root.dataset.tabsInit === 'true') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-faq-tab]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-faq-row]'));
    if (tabs.length < 2 || tabs.length !== rows.length) return;
    root.dataset.tabsInit = 'true';

    var current = 0;
    var panels = rows.map(function (row) {
      return row.querySelector('.accordion__panel');
    });

    tabs.forEach(function (tab, i) {
      if (panels[i]) {
        if (!panels[i].id) panels[i].id = tab.id + '-panel';
        tab.setAttribute('aria-controls', panels[i].id);
      }
    });

    /* Panel roles only while the tabs show: on phones the same panels are
     * plain accordion content under their summaries. */
    function applyRoles() {
      var on = desktop.matches;
      openCurrent();
      panels.forEach(function (panel, i) {
        if (!panel) return;
        if (on) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabs[i].id);
          panel.setAttribute('tabindex', '0');
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
      });
    }

    /* On desktop the chosen row must be open, or its hidden summary leaves
     * nothing to show. On phones the rows open and close as the visitor
     * chooses, so nothing is forced open there. */
    function openCurrent() {
      if (!desktop.matches) return;
      var details = rows[current].querySelector('details');
      if (details && !details.open) details.open = true;
    }

    function select(index, focus) {
      current = index;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        rows[i].classList.toggle('is-selected', on);
      });
      openCurrent();
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i, false);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            next = (current + 1) % tabs.length;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            next = (current - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = tabs.length - 1;
            break;
        }
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });

    /* A row opened on a phone becomes the chosen tab when the screen widens. */
    rows.forEach(function (row, i) {
      var details = row.querySelector('details');
      if (!details) return;
      details.addEventListener('toggle', function () {
        if (details.open && !desktop.matches && i !== current) {
          current = i;
          tabs.forEach(function (tab, j) {
            tab.setAttribute('aria-selected', j === i ? 'true' : 'false');
            tab.tabIndex = j === i ? 0 : -1;
            rows[j].classList.toggle('is-selected', j === i);
          });
        }
      });
    });

    var start = 0;
    tabs.forEach(function (tab, i) {
      if (tab.getAttribute('aria-selected') === 'true') start = i;
    });
    select(start, false);
    applyRoles();
    if (desktop.addEventListener) {
      desktop.addEventListener('change', applyRoles);
    } else if (desktop.addListener) {
      desktop.addListener(applyRoles);
    }
    root.setAttribute('data-tabs-ready', '');
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-faq-tabs]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* The theme editor re-renders a section in place. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
